import React, {Component} from 'react';
import logo from './logo.png';
import sublogo from './sublogo.png';
import './logo.css';

class Logo extends Component {
    render() {
        return(
            <div className="navbar-containers-icon">
                <img src={logo} alt="Logo principal" style={{maxWidth: '160px'}} />
            </div>
        ) 
    }
}

export default Logo;